import React from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { saveAs } from 'file-saver';
import { generateUrl } from '@magento/peregrine/lib/util/imageUtils';
import { DownloadResourceIcon, ImageFileIcon } from '/src/components';

var ImageResultItem = function ImageResultItem(_ref) {
  var item = _ref.item,
      name = _ref.name;

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;

  var downloadImage = function downloadImage() {
    return saveAs(generateUrl(item.file, 'image-product')('auto'), 'image.jpg');
  };

  return React.createElement("div", {
    className: "col-span-9"
  }, React.createElement("div", {
    className: "grid grid-cols-12 py-4 border-b border-solid border-snowbound items-center sm_py-3 sm_grid-cols-9"
  }, React.createElement("div", {
    className: "col-span-10 sm_col-span-6 flex items-center"
  }, !isSmallDevice && React.createElement(ImageFileIcon, null), React.createElement("a", {
    href: generateUrl(item.file, 'image-product')('auto'),
    target: "_blank",
    className: "pb-2 underline sm_no-underline sm_pb-0 sm_ml-2"
  }, name)), !isSmallDevice && React.createElement("div", {
    className: "col-span-1 sm_col-span-1 sm_text-right"
  }, React.createElement("button", {
    onClick: downloadImage,
    "aria-label": "Download Resource"
  }, React.createElement("span", {
    className: "sr-only"
  }, "Download Resource"), React.createElement(DownloadResourceIcon, null))), React.createElement("div", {
    className: "col-span-1 sm_col-span-1 sm_text-center text-bronze"
  }, item.size), React.createElement("div", {
    className: "col-span-1 sm_col-span-1 sm_text-center text-bronze"
  }, item.file_type)));
};

export default ImageResultItem;